<template>
  <div class="col-2">
    <h1>
      <span class="">{{ biogram_title }}</span>
    </h1>
    <div v-if="cover" class="biogram_cover">
      <img :src="cover" alt="" />
    </div>
    <div class="text-up">
      <p v-if="biogram_description" v-html="biogram_description" />
      <div class="icon-links to-right">
        <a :href="null"><i class="icon-fb"></i></a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NProgress from "nprogress";
import { eventBus } from "@/main.js";

export default {
  name: "BiogramHead",
  data() {
    return {
      biogram_title: null,
      biogram_description: null,
      cover: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      NProgress.start();

      axios
        .get(this.$config.API_PATH + "items/" + this.$route.params.id)
        .then((_resp) => {
          if (_resp.length == 0) {
            this.$router.push({
              name: "NotFound",
            });
          }
          // prevent /powiazane when item != 18

          if (this.$route.name == 'BiogramRelated' && _resp.data.item_type.id != 18) {
            this.$router.push({
              name: "NotFound",
            });
          }

          axios
            .get(this.$config.API_PATH + "files?item=" + this.$route.params.id)
            .then((_img) => {
              this.cover = require("@/assets/img/blank_portrait.jpg");

              if (_img.data.length != 0) {
                this.cover = _img.data[0].file_urls.fullsize;
              }

              let _metadata = _resp.data.element_texts;
              if (_metadata.find((x) => x.element.id == "52"))
                this.biogram_title = _metadata.find(
                  (x) => x.element.id == "52"
                ).text;
              this.$route.params.biogram_title = this.biogram_title;
              if (_metadata.find((x) => x.element.id == "61")) {
                this.biogram_description = _metadata.find((x) => x.element.id == "61").text;
              }
              eventBus.$emit("passBiogramTitle", this.biogram_title);

              // get cover image
            });
        })
        .catch((error) => {
          //console.log(error);
          this.$router.push({
            name: "NotFound",
          });
        });
      eventBus.$emit("headLoaded");
      NProgress.done();
    },
  },
};
</script>

<style scoped>
.text-up p a {
  color: red;
}

.biogram_cover img {}
</style>


// WEBPACK FOOTER //
// src/components/Heads/BiogramHead.vue